import List from "@/components/list";
const Table = args => {
  const { listeners, parent } = args;

  const AccountTableConfig = [
        {
          label: "姓名",
          prop: "userName"
        },
        {
          label: "工作单位",
          prop: "deptName"
        },
        {
          label: "单位及职务",
          prop: "unitPosition"
        },
      ];
  return (
    <List
      {...args}
      empty-text="暂无数据"
      height={380}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
